module.exports = __webpack_public_path__ + "static/img/wa04.1d1df7ef.png";